import { gql } from "@apollo/client";

const CONSULTATION_PRODUCTS = gql`
  query consultation_products_public($filter: FindManyConsultationProduct!) {
    consultation_products_public(filter: $filter) {
      __typename
      ... on ConsultationProduct {
        id
        message
        response
        product_id
        user_id
        user {
          firstname
        }
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

const CONSULTATION_PRODUCTS_ADMIN = gql`
  query consultation_products($filter: FindManyConsultationProduct!) {
    consultation_products(filter: $filter) {
      __typename
      ... on ConsultationProduct {
        id
        response
        message
        product {
          id
          name
          url_image
        }
        user {
          firstname
          lastname
          phone
        }
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export { CONSULTATION_PRODUCTS, CONSULTATION_PRODUCTS_ADMIN };
